module.exports = __webpack_public_path__ + "img/thrive4life-logo.db2c45ec.png";